import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type AuditBase from "@/pages/Audit.Base.vue";

export default defineMosaicComponent<typeof AuditBase>("pages/Audit");
